// RK 7/30/25 Accessibility: Close open header submenu on Escape key for keyboard users.
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    const focused = document.activeElement;
    const insideMenu = focused && focused.closest('.navigation__submenu, .submenu');

    if (insideMenu) {
      // Remove focus from submenu to collapse the menu
      focused.blur();

      // Optional: move focus back to menu toggle or top nav
      const mainNav = document.querySelector('.navigation');
      if (mainNav) {
        mainNav.focus();
      }
    }
  }
});

// RK 8/13/25 Accessibility: Background video - sync aria-pressed with real state (no duplicate click handler).
(function () {
  // Cache theme strings once (falls back to English)
  const STRINGS = (() => {
    const s = (window.theme && window.theme.strings) || {};
    return { play: s.playVideo || 'Play video', pause: s.pauseVideo || 'Pause video' };
  })();

  const seenVideos = new WeakSet();

  function hostOf(node) {
    return node.closest && node.closest('background-video');
  }

  function buttonsOf(host) {
    return host ? host.querySelectorAll('[js-video-pause-button]') : [];
  }

  function videoOf(host) {
    return host && host.querySelector('.current-video__container video');
  }

  function syncHost(host) {
    const vid = videoOf(host);
    if (!vid) return;
    const paused = vid.paused || vid.dataset.a11yPriorityPause === 'true';
    buttonsOf(host).forEach(btn => {
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      // Accessible name reflects the action (what will happen)
      btn.setAttribute('aria-label', paused ? STRINGS.play : STRINGS.pause);
    });
  }

  // Burst a few syncs after the theme's UI work has run
  function resyncBurst(host) {
    const doSync = () => syncHost(host);
    requestAnimationFrame(() => {
      doSync();
      setTimeout(doSync, 0);
      setTimeout(doSync, 60);
      setTimeout(doSync, 180);
    });
  }

  function bindVideo(vid) {
    if (!vid || seenVideos.has(vid)) return;
    seenVideos.add(vid);

    const host = hostOf(vid);
    if (!host) return;

    // Initial sync for this host/video
    syncHost(host);

    // Keep ARIA in sync when the video plays/pauses or the a11y flag flips
    vid.addEventListener('play', () => syncHost(host));
    vid.addEventListener('pause', () => syncHost(host));

    new MutationObserver(() => syncHost(host))
      .observe(vid, { attributes: true, attributeFilter: ['data-a11y-priority-pause'] });
  }

  function scanAll(root = document) {
    root.querySelectorAll('background-video .current-video__container video').forEach(bindVideo);
    // Ensure any hosts without a seen <video> still get synced once
    root.querySelectorAll('background-video').forEach(syncHost);
  }

  // 1) Initial scan
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scanAll());
  } else {
    scanAll();
  }

  // 2) Delegated click: after theme toggles, re-sync the host you clicked in
  document.addEventListener('click', (ev) => {
    const btn = ev.target && ev.target.closest && ev.target.closest('background-video [js-video-pause-button]');
    if (!btn) return;
    const host = hostOf(btn);
    if (!host) return;
    resyncBurst(host);
  }, true); // capture=true so we always see the click; we resync on the next ticks

  // 3) Watch for new videos/hosts (hydration, mobile/desktop swap)
  new MutationObserver((muts) => {
    muts.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(n => {
        if (!(n instanceof Element)) return;
        if (n.matches?.('background-video .current-video__container video')) {
          bindVideo(n);
        } else if (n.matches?.('background-video')) {
          scanAll(n);
        } else {
          n.querySelectorAll?.('background-video .current-video__container video').forEach(bindVideo);
          n.querySelectorAll?.('background-video').forEach(syncHost);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Honor prefers-reduced-motion
  const prm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (prm && prm.matches) {
    document.querySelectorAll('background-video .current-video__container video').forEach(v => {
      v.pause();
      v.dataset.a11yPriorityPause = 'true';
    });
  }
})();

// RK 8/21/25 Accessibility: Add ARIA label to "From Field to Formula" image hero section button.
// RK 10/15/25 Todo: Validate if this is still required.
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('a.btn[href="/pages/why-wildflower"]');
  if (btn) {
    btn.setAttribute('aria-label', 'Learn how quality begins at the source');
  }
});
// RK 8/21/25 Accessibility: Wrap <p> tags under headings in policy pages (WCAG 1.3.1).
// RK 10/15/25 Todo: Validate if this is still required.
// ADAALLY 11/13/25 Appply list semantic to the corresponding content (WCAG 1.3.1)
if (window.location.pathname.startsWith('/policies/')) {
  document.addEventListener('DOMContentLoaded', () => {
    const content = document.querySelector('.rte, #MainContent');
    if (!content) return;

    const heading = document.querySelector('#arbitration-agreement');

    const wrapper = document.createElement('div');
    wrapper.setAttribute('role', 'list');
    const firstNext = heading.nextElementSibling;
    let next = firstNext.nextElementSibling;
    while (next && next.tagName === 'P') {
      const listItem = next.cloneNode(true);
      listItem.setAttribute('role', 'listitem');
      wrapper.appendChild(listItem);
      const toRemove = next;
      next = next.nextElementSibling;
      toRemove.remove();
    }

    if (wrapper.children.length > 0) {
      firstNext.after(wrapper);
    }

  });
}


document.addEventListener('DOMContentLoaded', () => {

  //Also add aria-hidden true to the parent container
  function addInvisibleLabelToInputAndTextarea() {
    const optOut = document.querySelector('#pc--browser-opt-out-checkbox');
    if (optOut) {
      appendNewLabel(optOut, '_');
    }


    // ADAALLY 11/13/25 Add required (WCAG 3.3.2).
    const label = document.querySelector('.pc--opt-out-form-field label');
    if (label) {
      label.innerHTML = `${label.innerText}*`;
    }


    const observer = new MutationObserver(() => {
      const textAreas = document.querySelectorAll('[id^="g-recaptcha-response"], [id^="h-captcha-response"]');
      if (textAreas.length === 2) {
        textAreas.forEach(item => appendNewLabel(item, '-'));
        const parent = textAreas[0].parentNode;
        parent.setAttribute('aria-hidden', 'true');
        observer.disconnect();
      }
    })

    observer.observe(document.body, {
      subtree: true,
      childList: true
    });

    function appendNewLabel(element, divider) {
      const name = element.getAttribute('name').split(divider).join(' ');

      const newLabel = document.createElement('label');
      newLabel.className = 'visually-hidden';
      newLabel.innerText = name;
      newLabel.setAttribute('for', element.id);
      element.parentNode.insertBefore(newLabel, element);
    }
  }

  addInvisibleLabelToInputAndTextarea();

  // ADAALLY 11/13/25 Add fieldset to group of radios (WCAG 4.1.3)
  function addRoleAlertToSuccessAlert() {
    const params = new URLSearchParams(window.location.search);
    const isSuccess = params.get('success') === 'true';
    if (!isSuccess) return;

    const alert = document.querySelector('#pc--opt-out-success');
    if (alert) {
      alert.setAttribute('role', 'alert');
    }
  }
  addRoleAlertToSuccessAlert();


  function fixCartRedundantLinks() {
    const observer = new MutationObserver(() => {
      const cart = document.querySelector('dialog .cart-items');
      if (!cart) return;

      cart.querySelectorAll('cart-item').forEach(cartItem => {
        fixThumbnail(cartItem);
      });

      const cartObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1 && node.matches('cart-item')) {
              fixThumbnail(node);
            }
          }
        }
      });

      cartObserver.observe(cart, {
        childList: true,
        subtree: true
      });

      observer.disconnect();
    })
    observer.observe(document.body, {
      subtree: true,
      childList: true
    })

    document.querySelectorAll('.cart-items').forEach(cart => {
      cart.querySelectorAll('cart-item').forEach(cartItem => {
        fixThumbnail(cartItem);
      });
    });
  }


  /* 
  Fix redundant links on cart page and cart modal
  Remove alt from product images(decorative)
  Remove aria-label from product-item-minimal and product-item-minimal__image or dynamic class
  */
  function fixThumbnail(cartItem, imageLinkClass, titleLinkClass) {
    const imageClass = imageLinkClass || 'product-item-minimal__image';
    const titleClass = titleLinkClass || 'product-item-minimal__title';

    const img = cartItem.querySelector('img');
    if (img) {
      img.setAttribute('alt', '');
    }

    const innerContainer = cartItem.querySelector('.product-item-minimal');
    if (innerContainer) {
      innerContainer.removeAttribute('aria-label');
    }

    const imageLink = cartItem.querySelector(`a.${imageClass}`);
    const titleLink = cartItem.querySelector(`a.${titleClass}`);
    if (imageLink && titleLink) {
      imageLink.removeAttribute('aria-label');
      titleLink.removeAttribute('aria-label');
      const newLink = replaceLinkWithSpan(imageLink, titleLink);

      // ADAALLY 11/13/25 Add aria-hidden true to skip from screen reader (WCAG 1.3.2)
      newLink.setAttribute('aria-hidden', 'true');

      const quickBtn = cartItem.querySelector('button-with-state button');
      if (quickBtn) {
        quickBtn.setAttribute('aria-describedby', titleLink.id);
      }

    }
  }

  fixCartRedundantLinks();

  function fixRedundantLinksSearch() {
    const results = document.querySelector('.search-result-grid__results');
    if (!results) return;

    results.querySelectorAll(':scope > *').forEach((item) => {
      fixThumbnail(item, 'product-item__image', 'product-item__title');
    });

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;

          fixThumbnail(node, 'product-item__image', 'product-item__title');
        });
      }
    });

    observer.observe(results, {
      childList: true,
      subtree: false,
    });
  }

  fixRedundantLinksSearch();

  function replaceLinkWithSpan(link, secondLink, hasAttrLink, isSecondLinkHidden) {
    let newLink = link;

    if (hasAttrLink) {
      newLink.setAttribute('role', 'link');
      newLink.setAttribute('tabindex', isSecondLinkHidden ? '-1' : '0');
      if (isSecondLinkHidden) {
        newLink.setAttribute('aria-hidden', 'true');
      }
    } else {
      newLink = document.createElement('span');
      copyAttributes(link, newLink);
      newLink.innerHTML = link.innerHTML;
      link.replaceWith(newLink);
    }

    newLink.removeAttribute('href');
    newLink.removeAttribute('target');
    newLink.style.cursor = 'pointer';

    newLink.addEventListener('click', () => {
      secondLink.click();
    });

    newLink.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        secondLink.click();
      }
    });
    return newLink;
  }

  function copyAttributes(source, target) {
    if (!source || !target) return;

    for (const attr of source.attributes) {
      target.setAttribute(attr.name, attr.value);
    }
  }


  // Append logo to payments
  function appendLogoToPaymentsLogo() {
    document.querySelectorAll('.payment-icons title').forEach(item => {
      item.textContent = item.textContent.trim() + ' logo';
    })
  }
  appendLogoToPaymentsLogo();

  //  ADAALLY 11/13/25 Add listeners so filters work with Enter and Space (WCAG )
  function addEventListenerToFilters() {
    document.querySelectorAll('.custom-input input').forEach(item => {
      const focusOpenBtn = (item) => {
        const parent = item.closest('fieldset');
        if (parent) {
          const previous = parent.previousElementSibling;
          previous.focus();
        }
      }
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          item.click();
          focusOpenBtn();
        } else if (e.key === 'Escape') {
          document.dispatchEvent(new MouseEvent("click", { bubbles: true }));
          focusOpenBtn(item);
        }
      })
    });

    document.querySelectorAll('.disclosure-trigger').forEach(item => {
      const apply = () => {
        setTimeout(() => {
          const nextElement = item.nextElementSibling;
          const firstRadio = nextElement.querySelector('input[type="radio"]');
          if (firstRadio) {
            firstRadio.focus();
          }
        }, 100);
      };
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') apply();
      })
      item.addEventListener('click', () => apply())
    });
  }
  addEventListenerToFilters();

  //  ADAALLY 11/13/25 Trap focus to filter container (WCAG 4.1.2)
  function listenToOpenFilterBtnModal() {
    document.querySelectorAll('.search-top-bar__filter-button, .sticky-filter-sort__filter-button, .collection-top-bar__filter-button').forEach(btn => {
      const apply = () => {
        setTimeout(() => {
          const dialog = document.querySelector('dialog[open]');
          dialog.removeAttribute('aria-description');
          trapFocus(dialog);
        }, 300);
      };

      btn.addEventListener('click', () => apply());

      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') apply();
      });
    })
  }

  listenToOpenFilterBtnModal();

  function trapFocus(container, btnOpenModal, focusContainer, focusablesElements) {
    let focusables = []
    if (focusablesElements) {
      focusables = focusablesElements;
    } else {
      focusables = getFocusableElements(container);
    }
    console.log(focusables)
    if (focusables.length === 0) return;

    if (focusContainer) {
      container.focus();
    } else {
      focusables[0].focus();
    }


    container.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    const offEscape = onEscape(() => {
      if (btnOpenModal) {
        btnOpenModal.focus();
      }
    });

    function onEscape(handler) {
      function listener(e) {
        if (e.key === 'Escape' || e.key === 'Esc' || e.code === 'Escape') {
          handler(e);
        }
      }
      container.addEventListener('keydown', listener);
      return () => container.removeEventListener('keydown', listener);
    }
  }

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        `
          a[href]:not([tabindex="-1"]),
          button:not([disabled]):not([tabindex="-1"]),
          input:not([disabled]):not([type="hidden"]),
          select:not([disabled]),
          textarea:not([disabled]),
          [tabindex]:not([tabindex="-1"])
        `
      )
    );
  }

  //  ADAALLY 11/13/25 Trap focus to search container and arrowing through the search items (WCAG )
  function addFocusTrapAndArrowThroughItems() {
    const searchBtn = document.querySelector('.header__button--search')
    searchBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        searchBtn.click();
      }
    });
    searchBtn.addEventListener('click', () => applyListeners(searchBtn));

    const inputs = document.querySelectorAll('search-input input[type="search"]');
    const clearBtns = document.querySelectorAll('.search-input__clear-button');
    const onEmpty = (clearBtn, isHidden) => {
      clearBtn.setAttribute('tabindex', isHidden ? '-1' : '0');
      clearBtn.setAttribute('aria-hidden', String(!isHidden));
    };

    inputs.forEach((input, index) => {
      onEmpty(clearBtns[index], input.value.trim() === '');
      input.addEventListener('input', () => {
        onEmpty(clearBtns[index], input.value.trim() === '');
      });
    });

    function applyListeners(searchBtn) {
      setTimeout(() => {
        const modal = document.querySelector('dialog[open]');
        trapFocus(modal.querySelector('.drawer-header'), searchBtn);
        const input = modal.querySelector(".search-form search-input input[type='search']");

        const list = modal.querySelector("predictive-search-drawer");
        let items = [];

        // --- Watch for new items being added to the container ---
        const observer = new MutationObserver(() => {
          items = Array.from(modal.querySelectorAll(".drawer-content a, .predictive-search-drawer__footer-content a"));
          if (items.length) {
            items.forEach(item => item.setAttribute("tabindex", "-1"));
          }
        });

        observer.observe(list, { childList: true, subtree: true });

        // --- START: ArrowDown from input moves to first item ---
        input.addEventListener("keydown", e => {
          if (items.length <= 1) return;

          if (e.key === "ArrowDown") {
            e.preventDefault();
            setTimeout(() => {
              items[0].focus();
            }, 100);
          }
        });
        // --- END ---


        // --- Keyboard navigation inside results ---
        list.addEventListener("keydown", e => {
          const current = document.activeElement;
          const idx = items.indexOf(current);
          if (idx === -1) return;

          if (e.key === "ArrowDown") {
            e.preventDefault();
            const next = items[idx + 1] || items[0];
            next.focus();
          }

          if (e.key === "ArrowUp") {
            e.preventDefault();
            if (idx === 0) {
              input.focus();
            } else {
              items[idx - 1].focus();
            }
          }

          if (e.key === "Escape") {
            input.focus();
          }

          if (e.key === "Tab") {
            e.preventDefault();
            input.focus();
          }
        });
      }, 300);
    }
  }
  addFocusTrapAndArrowThroughItems();

  // ADAALLY 11/13/25 Set hero blog image to empty (WCAG 1.1.1)
  function setEmptyAltToBlogHeroImage() {
    const img = document.querySelector('.animating-image-wrap .image');
    if (img) {
      img.setAttribute('alt', '');
    }
  }

  setEmptyAltToBlogHeroImage();

  function fixRedudantLinkBlogs() {
    document.querySelectorAll('.blog__articles .blog-article-item').forEach(item => {
      const imageLink = item.querySelector('.blog-article-item__image');
      const titleLink = item.querySelector('.blog-posts-meta__title a');
      const btnLink = item.querySelector('.btn-wrapper a');
      const emptyLink = item.querySelector('.blog-article-item__link');
      if (imageLink && titleLink && btnLink) {
        replaceLinkWithSpan(titleLink, btnLink);
        replaceLinkWithSpan(imageLink, btnLink);
        replaceLinkWithSpan(emptyLink, btnLink);
        btnLink.setAttribute('aria-describedby', titleLink.id);
      }
    });
  }

  fixRedudantLinkBlogs();

  // ADAALLY 11/13/25 Set images alt to empty (WCAG 1.1.1)
  function setEmptyAltToCollectionsImages() {
    document.querySelectorAll('.list-collections .collection-item img').forEach(img => {
      img.setAttribute('alt', '');
    });
  }

  setEmptyAltToCollectionsImages();

  // / ADAALLY 11/13/25 Trap focus modal  (WCAG 4.1.2)
  function listeningToLearnMoreProductPage() {
    const learnMoreBtn = document.querySelector('.rk-repl__learnmore-trigger');
    if (!learnMoreBtn) return;

    learnMoreBtn.addEventListener('click', () => {
      setTimeout(() => {
        const container = document.querySelector('.rk-learn-modal__dialog');
        trapFocus(container, learnMoreBtn, true);
      }, 500);
    });

    learnMoreBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        learnMoreBtn.click();
      }
    });
  }

  listeningToLearnMoreProductPage();

  // ADAALLY 11/13/25  Hide redundant elements sticky container (WCAG 1.3.2)
  function toggleVisibilityFromProductPageStickyATC() {
    const stickyContent = document.querySelector('.sticky-atc');
    if (!stickyContent) return

    stickyContent.setAttribute('aria-hidden', 'true');
    stickyContent.querySelectorAll('button, a').forEach(item => {
      item.setAttribute('tabindex', '-1');
      item.setAttribute('aria-hidden', 'true');
    });
  }

  toggleVisibilityFromProductPageStickyATC();

  // ADAALLY 11/13/25 Add modal semantics (WCAG 4.1.2)
  function fixProductReviewModal() {
    const modalOpener = document.querySelector('.jdgm-write-rev-link');
    if (modalOpener) {
      modalOpener.addEventListener('click', () => {
        apply();
      });
    } else {
      const modalOpenerObserver = new MutationObserver(() => {
        const btn = document.querySelector('.jdgm-write-rev-link');
        if (!btn) return;
        btn.addEventListener('click', () => {
          apply();
        });
        modalOpenerObserver.disconnect();
      });

      modalOpenerObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    const apply = () => {
      modalOpener.setAttribute('aria-haspopup', 'dialog');
      modalOpener.setAttribute('aria-controls', 'jdgm-review-widget-modal');

      const reviewObserverInit = new MutationObserver(() => {
        const modal = document.querySelector('.jdgm-review-widget-modal');
        if (!modal) return;
        modal.id = 'jdgm-review-widget-modal';

        // ADAALLY 11/18/25 Give proper heading (WCAG 1.3.1)
        modal.querySelectorAll('.jdgm-write-review-modal__title, .jdgm-write-review-modal__product-title').forEach(title => {
          const newTitle = document.createElement('h1');
          newTitle.innerHTML = title.innerHTML;
          newTitle.className = title.className;
          title.replaceWith(newTitle);
        })
        reviewObserverInit.disconnect();
      });

      reviewObserverInit.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => {
        const modal = document.querySelector('.jdgm-review-widget-modal');
        if (!modal) return;
        modal.removeAttribute('role');
        modal.removeAttribute('aria-modal');
        const newModal = modal.querySelector('.jdgm-write-review-modal__content');
        newModal.setAttribute('role', 'dialog');
        newModal.setAttribute('tabindex', '-1');
        newModal.setAttribute('aria-label', 'Write a review');

        const checkbox = newModal.querySelector('#jdgm-anonymous-checkbox');
        checkbox.style.display = 'block';
        checkbox.classList.add('visually-hidden');

        const stars = Array.from(newModal.querySelectorAll('.jdgm-write-review-modal__stars a'));
        const firstStars = stars.slice(0, 5);
        const secondStars = stars.slice(5, 10);

        simulateHoverOnStars(firstStars);
        simulateHoverOnStars(secondStars);

        // ADAALLY 11/18/25 Give proper description to the stars and remove title (WCAG 4.1.2)
        stars.forEach((star) => {
          if (star.getAttribute('obs-aplied') !== 'true') {
            star.setAttribute('aria-label', star.getAttribute('title'));
            star.setAttribute('obs-aplied', 'true');
          }

          star.removeAttribute('title');
          new MutationObserver(mutations => {
            star.removeAttribute('title');
          }).observe(star, { attributes: true, attributeFilter: ['title'] });
        });

        // ADAALLY 11/18/25 Empty alt for decorative images (WCAG 1.1.1)
        const img = newModal.querySelector('.jdgm-write-review-modal__product-image img');
        if (img) {
          img.setAttribute('alt', '');
        }

        const focusableInactiveElements = (section) => {
          const elementsNotActive2 = section.querySelectorAll('.jdgm-write-review-modal__page:not(.current-page)');
          elementsNotActive2.forEach(item => {
            item.querySelectorAll('input, button, a').forEach(el => {
              el.setAttribute('tabindex', '-1');
            });
          })
        }
        const nextBtn = modal.querySelector('.jdgm-write-review-modal__nav-btn-next');
        const closeBtn = modal.querySelector('.jdgm-write-review-modal__close-btn');
        const sections = modal.querySelectorAll('.jdgm-write-review-modal__section');

        if (!sections.length) return;

        //ADAALLY 11/18/25 Focus the first element with error on the form WGCA(4.1.3)
        nextBtn.addEventListener('click', () => {
          const errors = newModal.querySelectorAll('input.error, textarea.error');
          if (errors.length) {
            errors[0].focus();
          }
        })

        const actionBtns = document.querySelectorAll('.jdgm-write-review-modal__nav-btn-back, .jdgm-write-review-modal__nav-btn-next');
        sections.forEach(section => {
          if (section.getAttribute('obs-aplied') === 'true') return;
          const firstPage = section.querySelector('.jdgm-write-review-modal__page--review-form-intro');
          if (closeBtn.getAttribute('applied') !== 'true') {
            firstPage.append(closeBtn);
            closeBtn.setAttribute('applied', 'true');
          }
          if (section.classList.contains("current-section")) {
            section.setAttribute('aria-hidden', 'false')
          } else {
            section.setAttribute('aria-hidden', 'true')
          }
          const observer = new MutationObserver(mutations => {
            mutations.forEach(m => {
              if (m.attributeName === "class") {
                const isActive = section.classList.contains("current-section");

                if (isActive) {
                  sections.forEach(sec => {
                    const isActive = sec.classList.contains("current-section");
                    sec.setAttribute('aria-hidden', String(!isActive))
                    sec.querySelectorAll('a, button, div, h1, p, input, textarea, span').forEach(el => {
                      el.setAttribute('aria-hidden', String(!isActive))
                      isActive ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', '-1');
                    });
                  });
                  setTimeout(() => {
                    const current = section.querySelector('.current-page');
                    if (current) {
                      focusableInactiveElements(section);
                      arrowKeysToStars(current);
                      trapFocus(newModal, modalOpener, false, [...current.querySelectorAll('a:not([tabindex="-1"]), input:not([type="hidden"]), button, textarea'), ...actionBtns]);
                    }

                    const inner = section.querySelector('.jdgm-write-review-modal__slider-container');
                    if (inner && !inner.getAttribute('obs-aplied')) {
                      inner.setAttribute('obs-aplied', 'true');

                      inner.querySelectorAll('.jdgm-write-review-modal__page').forEach(page => {
                        page.setAttribute('aria-hidden', String(!page.classList.contains('current-page')));
                      })

                      new MutationObserver(() => {
                        setTimeout(() => {
                          inner.querySelectorAll('.jdgm-write-review-modal__page').forEach(page => {
                            page.setAttribute('aria-hidden', String(!page.classList.contains('current-page')));
                          });

                          const currentPage = inner.querySelector('.current-page');
                          if (!currentPage) {
                            const btnFinal = newModal.querySelector('.jdgm-write-review-modal__nav-btn-close')
                            const lastView = newModal.querySelector('.jdgm-write-review-modal__page--thank-you');
                            lastView.querySelector('.jdgm-write-review-modal__form--thank-you .jdgm-write-review-modal__title').setAttribute('role', 'alert');
                            lastView.tabIndex = -1;
                            trapFocus(lastView, modalOpener, true, [btnFinal]);
                            btnFinal.setAttribute('click', () => {
                              reviewObserverInit.observe(document.body, {
                                childList: true,
                                subtree: true
                              });
                            });
                            return;
                          }

                          if (currentPage.getAttribute('obs-aplied') !== 'true') {
                            currentPage.append(newModal.querySelector('.jdgm-write-review-modal__navigation'));
                            currentPage.setAttribute('obs-aplied', 'true');
                          }

                          focusableInactiveElements(section);
                          const items = currentPage.querySelectorAll('a, input:not([type="hidden"]), button, textarea');

                          items.forEach(item => {
                            if (item.classList.contains('jdgm-star')) {
                              if (item.classList.contains('jdgm--on')) {
                                item.setAttribute('tabindex', '0');
                              }
                            } else {
                              item.removeAttribute('tabindex');
                            }
                          });
                          trapFocus(currentPage, modalOpener, false, [...items, ...actionBtns]);
                        }, 800);
                      }).observe(inner, { attributes: true, attributeFilter: ['style'] });
                    }
                  }, 500);
                }
              }
            });
          });

          observer.observe(section, {
            attributes: true,
            attributeFilter: ["class"]
          });

          section.setAttribute('obs-aplied', 'true');
        });

        const currentSection = newModal.querySelector('.current-section');
        if (currentSection) {
          arrowKeysToStars(currentSection);
          trapFocus(currentSection, modalOpener, false, [...currentSection.querySelectorAll('.jdgm-star[tabindex="0"]'), newModal.querySelector('.jdgm-write-review-modal__page--review-form-intro button')]);
        }
        modal.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            closeBtn.click();
            reviewObserverInit.observe(document.body, {
              childList: true,
              subtree: true
            });
          }
        });
      }, 500);
    };


    // ADAALLY 11/18/25 Replace before and after with real text (WCAG 1.3.1)
    function replacePoorAndGreatText(firstStar, lastStar, container) {
      container.style.position = 'relative';
      const poor = document.createElement('span');
      poor.className = 'poor-star';
      poor.innerText = 'Poor';
      container.prepend(poor);
      const great = document.createElement('span');
      great.className = 'great-star';
      great.innerText = 'Great';
      container.appendChild(great);
      poor.id = 'poor' + Math.random().toString(36).substring(2, 15);
      great.id = 'great' + Math.random().toString(36).substring(2, 15);
      firstStar.setAttribute('aria-describedby', poor.id);
      lastStar.setAttribute('aria-describedby', great.id);
    }

    // ADAALLY 11/18/25 Apply simulation of hovering (WCAG 2.4.7)
    function simulateHoverOnStars(stars) {
      const firstStar = stars[0];
      const lastStar = stars[stars.length - 1];
      const container = firstStar.parentNode;
      replacePoorAndGreatText(firstStar, lastStar, container);

      const CLASS = 'star-active';

      container.addEventListener('focusin', (event) => {
        const idx = stars.indexOf(event.target);
        if (idx === -1) return;
        stars.forEach((s, i) => s.classList.toggle(CLASS, i <= idx));
      });

      container.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!container.contains(document.activeElement)) {
            stars.forEach(s => s.classList.remove(CLASS));
          }
        }, 0);
      });
    }

    function arrowKeysToStars(container) {
      const group = container.querySelector('.jdgm-write-review-modal__stars');
      if (!group) return;

      const stars = Array.from(group.querySelectorAll('.jdgm-star'));
      const input = group.querySelector('input[name="score"]');

      // Upgrade semantics
      group.setAttribute('role', 'radiogroup');
      group.removeAttribute('aria-label')
      group.removeAttribute('role')
      stars.forEach((star, i) => {
        star.setAttribute('role', 'radio');
        star.setAttribute('aria-checked', 'false');
        star.tabIndex = i === 0 ? 0 : -1;
      });

      let index = 0;

      function updateFocusState() {
        stars.forEach((s, i) => {
          const isSelected = i === index;
          s.tabIndex = isSelected ? 0 : -1;
          s.setAttribute('aria-checked', isSelected);
        });
      }

      group.addEventListener('click', (e) => {
        const star = e.target.closest('.jdgm-star');
        if (!star) return;

        index = stars.indexOf(star);
        input.value = star.dataset.alt;
        updateFocusState();
      });

      group.addEventListener('keydown', (e) => {

        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          if (e.key === 'ArrowRight') index = Math.min(index + 1, stars.length - 1);
          if (e.key === 'ArrowLeft') index = Math.max(index - 1, 0);

          updateFocusState();
          stars[index].focus();
          return;
        }

        if (e.key === 'Enter') {
          e.preventDefault();
          const star = stars[index];

          input.value = star.dataset.alt;

          star.click();

          updateFocusState();
        }
      });
    }
  }
  fixProductReviewModal();

  /* 
    ADAALLY 11/13/25 Redundant links (WCAG 1.3.1)
    Fix redundant links on main product collections
    Remove alt from product images(decorative)
    Remove aria-label from product-item-minimal and product-item-minimal__image or dynamic class
*/
  function productsThumbnailFix() {
    const results = document.querySelector('.collection-product-grid__products');
    if (!results) return;

    results.querySelectorAll(':scope > * ').forEach(item => {
      fixThumbnail(item, 'product-item__image', 'product-item__title')
    });

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;

          fixThumbnail(node, 'product-item__image', 'product-item__title');
        });
      }
    });

    observer.observe(results, {
      childList: true,
      subtree: false,
    });
  }

  productsThumbnailFix();

  // ADAALLY 11/13/25 Toggle slide and list semantics on mobile (WCAG 1.3.1)
  function toggleListAndSliderSemantics() {
    document.querySelectorAll('scroll-slider-component').forEach(component => {
      const apply = () => {
        const isMobile = window.innerWidth < 720;
        const container = component.querySelector('.scroll-slider__slider');
        container.setAttribute('tabindex', '-1');
        const items = container.querySelectorAll('.icon-with-text-column');
        if (!items.length) return;

        const dots = document.querySelector('.scroll-slider-page-dots .scroll-slider-page-dots-inner');

        // ADAALLY 11/13/25 Toggle aria-hidden in dots when visible (WCAG 1.3.2)
        const parentDots = dots.parentNode;
        parentDots.setAttribute('aria-hidden', String(!isMobile));

        if (isMobile) {
          container.removeAttribute('role');
          container.removeAttribute('aria-label');

          // ADAALLY 11/13/25 Update global alert when slides are visible (WCAG 4.3.1)
          const globalAlert = document.getElementById('global-alert');

          // ADAALLY 11/13/25 Toggle aria-hidden to items when visible (WCAG 1.3.1)
          const handleIntersection = (entries) => {
            entries.forEach((entry) => entry.target.setAttribute('aria-hidden', String(!entry.isIntersecting)));
          };

          const observer = new IntersectionObserver(handleIntersection, {
            root: container,
            threshold: 0.5
          });

          items.forEach((item, index) => {
            item.setAttribute('role', 'group');
            item.setAttribute('aria-label', `Slide ${index + 1} of ${items.length}`);
            item.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
          });

          if (dots) {
            dots.setAttribute('role', 'list');
            setTimeout(() => {
              dots.querySelectorAll('.scroll-slider-page-dot-wrapper').forEach((item, index) => {
                item.setAttribute('role', 'listitem');
                const button = item.querySelector('button');
                button.setAttribute('aria-label', `Slide ${index + 1}`);

                // ADAALLY 11/17/25 Applying aria-current to see which one is active (WCAG 4.1.2)
                button.setAttribute('aria-current', button.classList.contains('active') ? 'true' : 'false');

                // ADAALLY 11/13/25 Applying the status alert by clicking the dots (WCAG 1.3.1)
                button.addEventListener('click', () => {
                  globalAlert.innerHTML = items[index].innerHTML;


                  // ADAALLY 11/17/25 Applying aria-current to see which one is active (WCAG 4.1.2)
                  dots.querySelectorAll('button').forEach(btn => {
                    btn.setAttribute('aria-current', 'false');
                  });
                  button.setAttribute('aria-current', 'true');
                });
              });
            }, 300);

            // ADAALLY 11/13/25 Update global alert when slides are visible (WCAG 4.3.1)
            dots.addEventListener('focusin', () => {
              globalAlert.setAttribute('aria-hidden', 'false');
              items.forEach((item) => observer.observe(item));
            });
            dots.addEventListener('focusout', () => {
              globalAlert.setAttribute('aria-hidden', 'true');
              globalAlert.innerHTML = '';
              observer.disconnect();
            })
          }
        } else {
          container.setAttribute('role', 'list');

          //We can make the name variable on the admin panel, right now is taking a default 'collection'
          container.setAttribute('aria-label', 'Brand highlights');
          items.forEach(item => {
            item.setAttribute('role', 'listitem');
            item.removeAttribute('aria-label');
          });
        }
      };

      apply();
      window.addEventListener('resize', apply);
    });
  }

  toggleListAndSliderSemantics();

  //ADAALLY 11/13/25 Add visually hidden text (WCAG 1.1.1)
  function listenToCartBarProgress() {
    const observer = new MutationObserver(() => {
      const bar = document.querySelector('.free-shipping-bar');
      if (!bar) return;

      const progress = getComputedStyle(bar)
        .getPropertyValue('--free-shipping-progress')
        .trim();

      const progressBar = document.querySelector('.free-shipping-bar__bar');
      if (!progressBar) return;

      if (progressBar.getAttribute('data-progress') !== progress) {
        progressBar.setAttribute('data-progress', progress);

        progressBar.querySelectorAll('.visually-hidden').forEach(n => n.remove());

        const hiddenText = document.createElement('span');
        hiddenText.classList.add('visually-hidden');
        hiddenText.textContent = `Free shipping progress: ${progress}`;

        progressBar.append(hiddenText);
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
    });
  }

  listenToCartBarProgress();

  //ADAALLY 11/13/25 Toggle visibility for screen reader when is hidden or not (WCAG 1.3.2).
  function toggleSubtotalVisibility() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    new MutationObserver(() => {
      const subtotal = drawer.querySelector('.cart-drawer__footer-subtotal');
      if (!subtotal) return;

      const isVisible = drawer.getAttribute('data-cart-text-is-visible') === 'true';

      subtotal.setAttribute('aria-hidden', isVisible ? 'true' : 'false');
    })
      .observe(drawer, {
        attributes: true,
        attributeFilter: ['data-cart-text-is-visible']
      });
  }

  toggleSubtotalVisibility();

  //ADAALLY 11/13/25 Fix redundant links  (WCAG 1.3.2).
  function waitForCartSlider() {
    const component = document.querySelector('scroll-slider-component');
    if (component) {
      component.querySelectorAll('.cross-sells-item').forEach((item) => {
        fixThumbnail(item);
        attachDescribedBy(item)
      });
    }

    const observer = new MutationObserver(() => {
      const cartSlider = document.querySelector('cart-drawer scroll-slider-component');
      if (cartSlider) {
        observer.disconnect();
        initializeSliderFix(cartSlider);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initializeSliderFix(cartSlider) {
    cartSlider.querySelectorAll('.cross-sells-item').forEach((el) => {
      fixThumbnail(el);
      attachDescribedBy(el);
    });

    const sliderObserver = new MutationObserver(mutations => {
      for (const m of mutations) {
        m.addedNodes.forEach(node => {
          if (node instanceof HTMLElement && node.matches('.cross-sells-item')) {
            fixThumbnail(node);
            attachDescribedBy(node);
          }
        });
      }
    });

    sliderObserver.observe(cartSlider, {
      childList: true,
      subtree: false
    });
  }

  // ADAALLY 11/13/25 add aria describedby to the quick btn (WCAG 2.4.4).
  function attachDescribedBy(item) {
    const title = item.querySelector('.product-item-minimal__title');
    const quickBtn = item.querySelector('button-with-state button');

    if (!title || !quickBtn) return;

    if (!title.id) {
      title.id = `product_other_${crypto.randomUUID()}`;
    }

    quickBtn.setAttribute('aria-describedby', title.id);
  }

  waitForCartSlider();


  //ADAALLY 11/16/25 Make select work with arrows (WCAG 2.1.1).
  function setupVariantArrowsOnly() {
    const dropdown = document.querySelector('.variant-dropdown--siblings');
    if (!dropdown) return;
    const btn = dropdown.querySelector('.variant-dropdown__toggle');
    const panel = dropdown.querySelector('[js-variant-dropdown-panel]');
    const options = [...dropdown.querySelectorAll('[js-variant-dropdown-option]')];

    panel.addEventListener('focusout', e => {
      if (!dropdown.contains(e.relatedTarget)) {
        btn.click();
      }
    });

    options.forEach((opt, index) => {
      opt.addEventListener('click', () => {
        setTimeout(() => {
          panel.style.maxHeight = '0px';
          panel.style.visibility = 'hidden';
          btn.focus();
        }, 100);
      })
      opt.addEventListener('keydown', e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          panel.style.maxHeight = '0px';
          panel.style.visibility = 'hidden';
          btn.click()
          btn.focus();
          return;
        }

        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

        e.preventDefault();

        let nextIndex = e.key === 'ArrowDown' ? index + 1 : index - 1;

        if (nextIndex < 0 || nextIndex >= options.length) return;

        options[nextIndex].focus();
      });
    });
  }

  setupVariantArrowsOnly();

  //ADAALLY 11/16/25 Update aria label (WCAG 4.1.2).
  function updateAriaLabelFromCollextions() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(() => {
        const item = cartDrawer.querySelector('.scroll-slider__slider');
        if (!item) return;
        const parent = item.closest('visibility-watcher');
        if (!parent) return;
        const heading = parent.querySelector('.cross-sells__heading');
        if (heading) {
          item.setAttribute('aria-label', heading.innerText);
        }
        observer.disconnect();
      });
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }

    document.querySelectorAll('.scroll-slider__slider').forEach(item => {
      if (item.getAttribute('aria-label') !== 'Collection') return;

      const parent = item.closest('visibility-watcher');
      if (!parent) return;
      const heading = parent.querySelector('.cross-sells__heading');
      if (heading) {
        item.setAttribute('aria-label', heading.innerText);
      }
    })
  }

  updateAriaLabelFromCollextions();

  // ADAALLY 11/17/25 Toggle slide and list semantics - sliders (WCAG 1.3.1)
  function collectionSliders() {
    document.querySelectorAll('.section-slider-wrap-outer').forEach(component => {
      const isSlide = component.querySelector('scroll-slider-with-scroll-indicator');
      const sliderContainer = component.querySelector('.scroll-slider__slider');
      if (isSlide) {
        sliderContainer.removeAttribute('role');
        sliderContainer.removeAttribute('aria-label');

        // ADAALLY 11/13/25 Toggle aria-hidden to items when visible (WCAG 1.3.1)
        const handleIntersection = (entries) => {
          entries.forEach((entry) => toggleVisibility(entry.target, entry.isIntersecting));
        };

        const observer = new IntersectionObserver(handleIntersection, {
          root: sliderContainer,
          threshold: 0.5
        });

        const items = sliderContainer.querySelectorAll(':scope > div');
        items.forEach((item, index) => {
          item.setAttribute('aria-label', `Slide ${index + 1} of ${items.length}`);
          item.setAttribute('role', 'group');
          const innerItem = item.querySelector('product-item');
          if (innerItem) {
            innerItem.removeAttribute('role');
          }

          const titleLink = item.querySelector('.product-item__title');
          const imageLink = item.querySelector('.product-item__image');
          if (titleLink && imageLink) {
            const span = replaceLinkWithSpan(imageLink, titleLink);
            span.setAttribute('aria-hidden', 'true');
            span.querySelector('img')?.setAttribute('alt', '');
          }

          observer.observe(item);
        });
        handleIntersection(
          [...items].map(item => ({
            target: item,
            isIntersecting: true
          }))
        );

      } else {
        sliderContainer.setAttribute('role', 'list');
        sliderContainer.querySelectorAll(':scope > div').forEach(item => {
          item.removeAttribute('aria-label');
          item.setAttribute('role', 'listitem');
          const innerItem = item.querySelector('product-item');
          if (innerItem) {
            innerItem.removeAttribute('role');
          }
        });
      }
    })

    function toggleVisibility(item, isVisible) {
      item.setAttribute('aria-hidden', String(!isVisible));
      item.querySelectorAll('button, a').forEach(focusableItem => {
        focusableItem.setAttribute('aria-hidden', String(!isVisible));
        focusableItem.setAttribute('tabindex', isVisible ? '0' : '-1');
      })
    }
  }

  collectionSliders();

  // ADAALLY 11/17/25 Toggle visibility when hidden, fix enter on tab when navigating on menu mobile (WCAG 1.3.2)
  function toggleVisibilityMenu() {
    if (window.innerWidth >= 1024) return;

    function hideAll() {
      document.querySelectorAll(
        '.navigation__submenu input, .navigation__submenu a, .navigation__submenu .submenu-header__control--back, .navigation__submenu .submenu-header__title, .navigation__submenu .submenu__list, .navigation__submenu .submenu__item'
      ).forEach(el => setHidden(el, true));
    }

    function setHidden(el, hidden) {
      el.setAttribute('tabindex', hidden ? '-1' : '0');
      el.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    }

    function enableItems(list) {
      list.forEach(el => setHidden(el, false));
    }

    function setupEnterAsClick(el) {
      el.addEventListener('keydown', e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          el.click();
        }
      });
    }

    function querySubmenu(parent, selector) {
      return parent.querySelector(`.submenu ${selector}`);
    }

    hideAll();

    const openBtn = document.querySelector('.navigation__control');
    if (!openBtn) return;

    function apply() {
      const rootSubmenu = document.querySelector('.navigation__submenu');
      const closeBtn = rootSubmenu.querySelector('.navigation__control-close');
      const primaryItems = [
        ...rootSubmenu.querySelectorAll(`
    .submenu__inner--primary > .submenu__list > .submenu__item > .submenu__list-control > .submenu__list-control-input,
    .submenu__inner--primary > .submenu__list > .submenu__item > .submenu__link:not(.submenu__parent-item),
    .navigation__cross-border-account a
  `)
      ];
      const handleEscape = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          hideAll();
          const event = new KeyboardEvent('keydown', {
            key: 'Enter',
            code: 'Enter',
            keyCode: 13,
            which: 13,
            bubbles: true
          });

          closeBtn.dispatchEvent(event);
          openBtn.querySelector('input[type="checkbox"]').setAttribute('aria-expanded', 'false');
        }
      };

      // Remove
      rootSubmenu.removeEventListener('keydown', handleEscape);
      // Add
      rootSubmenu.addEventListener('keydown', handleEscape);

      document.querySelector('.submenu__inner--primary > .submenu__list').setAttribute('aria-hidden', 'false');
      document.querySelector('.submenu__inner--primary > .submenu__list').removeAttribute('tabindex');
      document.querySelectorAll('.submenu__inner--primary > .submenu__list > .submenu__item').forEach(label => {
        label.setAttribute('aria-hidden', 'false');
        label.removeAttribute('tabindex');
      });

      enableItems(primaryItems);
      primaryItems.forEach(item => {
        setupEnterAsClick(item);
        item.addEventListener('click', () => {
          handlePrimaryClick(item, () => {
            enableItems(primaryItems);
            trapFocus(rootSubmenu, openBtn, false, primaryItems);
          });
        });
      });

      trapFocus(rootSubmenu, openBtn, false, primaryItems);
    }

    // -----------------------------
    // Submenu Handlers
    // -----------------------------

    function handlePrimaryClick(item, callback) {
      hideAll();

      const parent = item.closest('li');
      const submenu = querySubmenu(parent, '.submenu__inner--secondary .submenu__list') || querySubmenu(parent, '.submenu__inner--secondary .submenu__navigation-promos');

      if (!submenu) return;
      const back = parent.querySelector('.submenu-header__control--back[role="button"]');
      setHidden(back, false);

      const inputs = [...parent.querySelectorAll('.submenu__inner--secondary .submenu__list > li > label > input, .submenu__inner--secondary  .navigation-promos--second > .navigation-promo > .navigation-promo__link')];
      enableItems(inputs);
      submenu.setAttribute('aria-hidden', 'false');
      submenu.removeAttribute('tabindex');
      submenu.querySelectorAll('.submenu__item').forEach(label => {
        label.setAttribute('aria-hidden', 'false');
        label.removeAttribute('tabindex');
      });

      inputs.forEach(subItem => {
        setupEnterAsClick(subItem);
        subItem.addEventListener('click', () => {
          handleSecondaryClick(subItem, () => {
            enableItems(inputs);
            trapFocus(submenu, item, false, [back, ...inputs]);
          })
        });
      });

      trapFocus(parent, item, false, [back, ...inputs]);
      back.addEventListener('click', () => {
        hideAll();
        if (typeof callback === "function") {
          callback();
        }
      })

      back.addEventListener('keydown', e => {
        if (e.key === 'Enter') {
          back.click();
        }
      });
    }

    function handleSecondaryClick(subItem, callback) {
      hideAll();

      const parentChild = subItem.closest('li');
      const submenuChild = querySubmenu(parentChild, '.submenu__inner--tertiary .submenu__list');
      if (!submenuChild) return;

      const back = parentChild.querySelector('.submenu-header__control--back[role="button"]');
      setHidden(back, false);
      submenuChild.setAttribute('aria-hidden', 'false');
      submenuChild.removeAttribute('tabindex');
      submenuChild.querySelectorAll('.submenu__item').forEach(label => {
        label.setAttribute('aria-hidden', 'false');
        label.removeAttribute('tabindex');
      });
      const links = [...submenuChild.querySelectorAll(':scope > li > a')];
      enableItems(links);

      links.forEach(link => setupEnterAsClick(link));

      trapFocus(submenuChild, subItem, false, [back, ...links]);

      back.addEventListener('click', () => {
        hideAll();
        if (typeof callback === "function") {
          callback();
        }
      })

      back.addEventListener('keydown', e => {
        if (e.key === 'Enter') {
          back.click();
        }
      });
    }

    // -----------------------------
    // Open handlers
    // -----------------------------

    openBtn.addEventListener('click', () => {
      //Workaround to simulate the key enter and make the first element focusable on click
      openBtn.dispatchEvent(new KeyboardEvent("keydown", { key: "Enter" }));
      const item = document.querySelector('.submenu__item .submenu__list-control span');
      setTimeout(() => {
        item.tabIndex = -1;
        item.focus();
      }, 300)
    });
    openBtn.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        openBtn.querySelector('input[type="checkbox"]').setAttribute('aria-expanded', 'true');
        apply();
      }
    });
  }
  toggleVisibilityMenu();

  //ADAALLY 11/19/25 Show submenus on arrow event (WCAG).
  function addArrowToToggleSubMenu() {
    if (window.innerWidth < 1024) return;
    const parents = document.querySelectorAll('.submenu__item--parent');

    const hideSubmenu = (submenu) => {
      submenu.classList.remove('menu-opacity-1');
      submenu.classList.add('menu-opacity-0');
      toggleSubmenuVisibility(submenu, false);
    };

    const showSubmenu = (submenu) => {
      submenu.classList.remove('menu-opacity-0');
      submenu.classList.add('menu-opacity-1');
      toggleSubmenuVisibility(submenu, true);
    };

    parents.forEach((item, index) => {
      const link = item.querySelector('.submenu__link');
      const arrow = item.querySelector('.icon-toggle');
      const submenu = item.querySelector('.submenu');

      toggleSubmenuVisibility(submenu, false);
      if (!arrow) return;
      link.id = `nav_item_${index}`;
      arrow.setAttribute('aria-labelledby', link.id);

      const onFocusIn = () => {
        submenu.classList.add('menu-opacity-0');
      };

      const onFocusOut = (e) => {
        if (item.contains(e.relatedTarget)) return;
        hideSubmenu(submenu);
        arrow.setAttribute('aria-expanded', 'false');
      };

      item.addEventListener('mouseleave', () => {
        hideSubmenu(submenu);
        arrow.setAttribute('aria-expanded', 'false');
      });

      item.addEventListener('mouseenter', () => {
        submenu.classList.remove('menu-opacity-1', 'menu-opacity-0');
      });

      item.addEventListener('focusin', onFocusIn);
      item.addEventListener('focusout', onFocusOut);
      arrow.addEventListener('focusout', onFocusOut);

      arrow.addEventListener('click', () => {
        if(submenu.classList.contains('menu-opacity-1')) {
          hideSubmenu(submenu);
          arrow.setAttribute('aria-expanded', 'false');
        } else {
          showSubmenu(submenu);
          arrow.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      const focused = document.activeElement;
      const insideMenu = focused && focused.closest('.navigation__submenu, .submenu');
      if (!insideMenu) return;

      insideMenu.blur?.();
      hideSubmenu(insideMenu);
    });

    function toggleSubmenuVisibility(submenu, isVisible) {
      submenu.setAttribute('aria-hidden', String(!isVisible));
      submenu.querySelectorAll('a').forEach(link => {
        link.setAttribute('tabindex', isVisible ? '0' : '-1');
      });
    }
  }

  addArrowToToggleSubMenu();

  // ADAALLY 11/17/25 Add a description to the qick view button (WCAG 4.1.2)
  function addDescriptionToProductQuickViewModal() {
    new MutationObserver(() => {
      const modal = document.querySelector('dialog.product-quick-view[open]');
      if (!modal) return;

      const description = modal.querySelector('.product-details__title');
      if (!description) return;
      description.id = `quick_view_title_${crypto.randomUUID()}`;
      modal.setAttribute('aria-labelledby', description.id);

      // ADAALLY 11/18/25 Set images' alt to empty(decorative) (WCAG 1.1.1)
      modal.querySelectorAll('img').forEach(img => {
        img.setAttribute('alt', '');
      });

      // ADAALLY 11/18/25 Set expanded to false because it stars closed (WCAG 4.1.2)
      const accordionBtn = modal.querySelector('.rk-acc__summary');
      if (accordionBtn) {
        accordionBtn.setAttribute('aria-expanded', 'false');
      }

    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  addDescriptionToProductQuickViewModal();

  // ADAALLY 11/20/25 Add functionality so fake items work as radio inputs (WCAG)
  function fixReplenishmentRadioSemantics() {
    document.querySelectorAll(".rk-acc__panel [role='radiogroup']").forEach(group => {
      group.addEventListener("focus", (e) => {
        if (group.contains(e.relatedTarget)) return;

        const items = getRadioLikeItems(group);

        const checkedRadio = group.querySelector("input[type='radio']:checked");

        if (checkedRadio) {
          const tile = checkedRadio.closest(".rk-repl__tile, .rk-repl__tile--sub");
          const fakeBtn = tile?.querySelector(".rk-repl__btnlike, [data-rk-plan-toggle]");
          if (fakeBtn) {
            fakeBtn.focus();
            setTabIndexes(items, items.indexOf(fakeBtn));
            return;
          }
        }

        items[0].focus();
        setTabIndexes(items, 0);
      }, true);

      const items = getRadioLikeItems(group);
      setTabIndexes(items, 0);

      items.forEach((item, index) => {
        item.addEventListener("keydown", e => {
          let nextIndex = null;

          if (e.key === "ArrowRight" || e.key === "ArrowDown") {
            nextIndex = (index + 1) % items.length;
          }
          if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
            nextIndex = (index - 1 + items.length) % items.length;
          }

          if (nextIndex != null) {
            e.preventDefault();
            items[nextIndex].focus();
            setTabIndexes(items, nextIndex);
            activateHiddenRadio(items[nextIndex]);
            autoOpenIfSubscribe(items[nextIndex]);
          }
        });

        item.addEventListener("click", () => {
          activateHiddenRadio(item);
          const idx = items.indexOf(item);
          setTabIndexes(items, idx);
          autoOpenIfSubscribe(item, true);
        });
      });
    });

    function getRadioLikeItems(group) {
      return Array.from(group.querySelectorAll(".rk-repl__btnlike, [data-rk-plan-toggle]"));
    }

    function setTabIndexes(items, activeIndex) {
      items.forEach((btn, idx) => btn.tabIndex = idx === activeIndex ? 0 : -1);
    }

    function activateHiddenRadio(fakeBtn) {
      const tile = fakeBtn.closest(".rk-repl__tile, .rk-repl__tile--sub");
      if (!tile) return;
      const hiddenRadio = tile.querySelector("input[type='radio']");
      if (hiddenRadio) {
        hiddenRadio.checked = true;
        hiddenRadio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    function autoOpenIfSubscribe(fakeBtn, notAutoOpen) {
      const dropdownToggle = fakeBtn.closest(".rk-repl__tile--sub")?.querySelector("[data-rk-plan-toggle]");
      if (!dropdownToggle) return;

      if (!notAutoOpen) {
        dropdownToggle.click();
      }

      setTimeout(() => {
        syncFirstOptionToRadio(dropdownToggle);
        const panel = document.getElementById(dropdownToggle.getAttribute("aria-controls"));
        const firstOption = panel?.querySelector("[role='option']");
        if (firstOption) firstOption.focus();
      }, 50);
    }

    function syncFirstOptionToRadio(dropdownToggle) {
      const panel = document.getElementById(dropdownToggle.getAttribute("aria-controls"));
      if (!panel) return;

      const options = panel.querySelectorAll("[role='option']");
      if (!options.length) return;

      const firstOption = options[0];

      if (firstOption.getAttribute("aria-selected") === "true") {
        const tile = dropdownToggle.closest(".rk-repl__tile--sub");
        if (!tile) return;

        const hiddenRadio = tile.querySelector("input[type='radio']");
        if (hiddenRadio) {
          hiddenRadio.checked = true;
          hiddenRadio.dispatchEvent(new Event("change", { bubbles: true }));
        }

        setTimeout(() => firstOption.focus(), 30);
      }
    }
  }

  fixReplenishmentRadioSemantics();

/* ADAALLY 11/25/2025 Remove sticky filter on 350%+ zoom  WCGA(2.4.11)*/
  const originalWidth = window.innerWidth;
  function checkZoom() {
    const currentWidth = window.innerWidth;
    const zoomLevel = originalWidth / currentWidth;

    document.querySelectorAll('.collection-product-grid__sticky-filter-sort-button, .search-result-grid__sticky-filter-sort-button')
      .forEach(el => {
        if (zoomLevel >= 3.5) {
          el.classList.add('zoom-hidden');
        } else {
          el.classList.remove('zoom-hidden');
        }
      });
  }

  checkZoom();
  window.addEventListener('resize', checkZoom);
});

